import {faBed, faBedPulse, faBookAtlas, faBroomBall, faCalendarDays, faCommentDollar} from "@fortawesome/free-solid-svg-icons";
import AppLink from "components/common/AppLink";
import Page from "components/common/page/Page";
import TabNav from "components/common/tabs/TabNav";
import TabNavLink from "components/common/tabs/TabNavLink";
import Translate from "components/common/Translate";
import { AppRoutes } from "config/router";
import { Outlet, useLocation } from "react-router-dom";

const AccommodationSettingsPage = () => {
    const location = useLocation();

    const settingsSections = [
        {
            title: 'pages.accommodation.settings.rooms-and-types',
            name: 'roomAndRoomTypes',
            icon: faBed,
            path: AppRoutes.ACCOMMODATION_ROOM_AND_TYPE_SETTINGS
        },
        {
            title: 'pages.accommodation.eventTemplate.list',
            name: 'eventTemplate',
            icon: faCalendarDays,
            path: AppRoutes.ACCOMMODATION_EVENT_TEMPLATE_DATALIST
        },
        {
            title: 'pages.accommodation.additionalChargesTemplate.list',
            name: 'additionalChargesTemplate',
            icon: faCommentDollar,
            path: AppRoutes.ACCOMMODATION_ADDITIONAL_CHARGES_TEMPLATE_DATALIST
        },
        {
            title: 'pages.accommodation.channel.list',
            name: 'bookingChannels',
            icon: faBookAtlas,
            path: AppRoutes.ACCOMMODATION_CHANNELS
        },
        {
            title: 'pages.accommodation.work.maintenance-type.list',
            name: 'maintenanceType',
            icon: faBroomBall,
            path: AppRoutes.ACCOMMODATION_MAINTENANCE_TYPE
        }
    ]

    const getLinks = () => {
        const lis = settingsSections.map((section) => {
            return (
                <li className="pt-2 text-lg" key={section.name}>
                    <AppLink to={section.path}>
                        <Translate i18nKey={section.title} />
                    </AppLink>
                </li>
            )
        });

        return (
            <Page title="pages.accommodation.settings">
                <ul className="list-disc p-4">
                    {lis}
                </ul>
            </Page>
        );
    }

    const getTabs = () => {
        const tabs = settingsSections.map((section) => {
            return (
                <TabNavLink key={section.name} to={section.path} icon={section.icon} text={section.title} />
            );
        });

        return (
            <div className="app-tabs">
                <TabNav>
                    {tabs}
                </TabNav>
                <Outlet />
            </div>
        )
    };


    return location.pathname === AppRoutes.SETTINGS_ACCOMMODATION_PAGE ? getLinks() : getTabs();
}

export default AccommodationSettingsPage;
